<template>
  <div>
    <v-form ref="refMain">
      <v-container fluid>
        <v-row fluid>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-autocomplete v-model="dOrgId" label="* Unidad de Negocio"
                            :items="dOrg"  item-value="IdCentProd" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" class="pa-1">
            <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                            :items="dPriServicios"  item-value="IdServicio" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-menu
                v-model="dFInicioMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFInicio"
                    label="Fecha Inicio Seccion Desde"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFInicio"
                  @input="dFInicioMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-menu
                v-model="dFFinMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFFin"
                    label="Fecha Inicio Seccion Hasta"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFFin"
                  @input="dFFinMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-select v-model="dEnviado" label="Estado"
                      :items="[{text: 'PENDIENTE', value: '0,2,3,4,90,91,92'},
                                    {text: 'FINALIZADO', value: '1'}]"
                      filled prepend-inner-icon="invert_colors"></v-select>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" class="pa-1">
            <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon>search</v-icon> Buscar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-data-table
        v-model="dTable.selected"
        :headers="dTable.headers"
        :items="dMatSeccions"
        :loading="dTable.loading"
        :search="dTable.search"
        item-key="IdSeccion"
        show-select
        class="elevation-1">
      <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
      <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
      <template v-slot:[`item.matperiodo`]="{ item }">
        <span>{{item.Anio +"-"+item.Periodo}}</span>
      </template>
      <template v-slot:[`item.Seccion`]="{ item }">
        <span>{{item.Nivel+"° "+item.Seccion}}</span>
      </template>
      <template v-slot:[`item.Enviado`]="{ item }">
        <span>{{item.Enviado | fiEstado}}</span>
      </template>
      <template v-slot:[`item.Lms`]="{ item }">
        <span>{{item.Lms | fiLms}}</span>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <div class="pa-2 blue-grey darken-2">
      <v-btn @click.prevent="fuSave" class="ma-1" :loading="dIsUpdating" color="primary"><v-icon left>autorenew</v-icon> Reiniciar Proceso</v-btn>
      <v-btn @click="fuExecute" color="deep-orange" class="white--text ma-1"><v-icon left>autorenew</v-icon> Cambiar Lms</v-btn>

      <v-dialog v-model="dCambiarLmsModal.dialog" max-width="500">
        <template>
          <v-card>
            <v-toolbar class="justify-end" color="blue-grey" dark>
              <v-spacer></v-spacer>
              <v-btn color="blue-grey" @click="fuUpdateLms" :loading="dCambiarLmsModal.IsUpdating"><v-icon>do_disturb_on</v-icon> Cambiar</v-btn>
              <v-btn @click="dCambiarLmsModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-alert dense text type="info">
                Ha seleccionado <strong>{{this.dTable.selected.length}}</strong> secciones
              </v-alert>
              <v-autocomplete label="Lms:" v-model="dLmsId" :items="dLms" filled prepend-inner-icon="invert_colors"/>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>
    </div>
    <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
      <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
  name: 'MatSeccion',
  data: () => ({
    dEnviado: '0,2,3,4,90,91,92',
    dFInicio: moment().subtract(30,'d').format('YYYY-MM-DD'),
    dFInicioMenu: false,
    dFFin: moment().format('YYYY-MM-DD'),
    dFFinMenu: false,
    dIsUpdating: false,
    dMatSeccions: [],
    dSnackbar: false,
    dCambiarLmsModal: {
      dialog: false,
      IsUpdating: false,
    },
    dIdServicio: null,
    dPriServicios: [],
    dOrgId: '',
    dOrg: [],
    dLmsId: 1,
    dLms: [
      {value: 1, text: '1 - Teams' },
      {value: 2, text: '2 - Moodle' },
      {value: 3, text: '3 - Canvas - Instructure' },
      {value: 4, text: '4 - Canvas - Khipu' },
      {value: '', text: 'Otro' },
    ],
    dTable: {
      headers: [
        {value: 'IdSeccion', text: 'IdSeccion', align: ' d-none'},
        {value: 'Iniciales', text: 'Prog. Est.'},
        {value: 'Periodo', text: 'Periodo'},
        {value: 'Seccion', text: 'Seccion'},
        {value: 'FechaInicio', text: 'Fecha Inicio Seccion'},
        {value: 'FechaFin', text: 'Fecha Fin Seccion'},
        {value: 'Enviado', text: 'Estado'},
        {value: 'Lms', text: 'Lms'}
      ],
      loading: false,
      search: null,
      selected: []
    },
    Usuario: null
  }),
  mounted(){
    this.Usuario = JSON.parse(localStorage.getItem('ssUser'))
    this.fuLoadOrg(this.Usuario)
  },
  watch: {
    'dOrgId' (val) {
      this.fuLoad(val);
    }
  },
  methods: {
    async fuLoad(Unidad){
      const response = await this.$apollo.query({
        query: gql`query priservicioByIdCentroProdByActivo($IdCentroProd: Int!){
                    priservicioByIdCentroProdByActivo (IdCentroProd: $IdCentroProd, Activo: 1){
                      IdServicio
                      Descripcion
                    }
                }`,
        variables: {
          IdCentroProd: Unidad
        }
      })
      this.dPriServicios = response.data.priservicioByIdCentroProdByActivo;
    },
    async fuLoadOrg(User){
      const response = await this.$apollo.query({
        query: gql`query centProdLmsUsuario($Usuario: String!){
                    centProdLmsUsuario(Usuario: $Usuario){
                      IdCentProd
                      Descripcion
                      Usuario
                    }
                }`,
        variables: {
          Usuario: User.Usuario
        }
      })
      this.dOrg = response.data.centProdLmsUsuario;
    },
    fuSearch(){
      if(!this.$refs.refMain.validate()){
        this.dSnackbar = true;
      } else {
        this.fuMatseccionByActivaByEnviadoByFechas();
      }
    },
    fuExecute(){
      if(!this.dTable.selected){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        if(this.dTable.selected.length==0)
          Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
        else
          this.dCambiarLmsModal.dialog = true;
      }
    },
    async fuMatseccionByActivaByEnviadoByFechas(){
      this.dTable.selected = [];
      this.dTable.loading = true;
      let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
      let vFFin =this.dFFin.substring(0,10).split("-").join("");
      try {
        const response = await this.$apollo.query({
          query: gql`query matseccionesLmsCentProd($IdCentroProd: Int!, $FInicio: String!, $FFin: String!, $IdServicio: String!, $Enviado: String!){
                      matseccionesLmsCentProd(IdCentroProd:$IdCentroProd, FechaInicio:$FInicio, FechaFin:$FFin, IdServicio:$IdServicio, Enviado:$Enviado){
                      IdSeccion
                      FechaInicio
                      FechaFin
                      Seccion
                      Anio
                      Periodo
                      Nivel
                      Iniciales
                      Enviado
                      Lms
                    }
          }`,
          variables: {
            IdCentroProd: this.dOrgId,
            FInicio: vFInicio,
            FFin: vFFin,
            IdServicio: this.dIdServicio,
            Enviado: this.dEnviado,
            token: new Date().toISOString()
          },
          fetchPolicy: 'no-cache'
        })
        this.dMatSeccions = [];
        this.dMatSeccions = response.data.matseccionesLmsCentProd;
        console.log(this.dMatSeccions);
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dTable.loading = false
      }
    },
    fuSave(){
      console.log();
      if(this.dTable.selected.length===0){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        this.fuMatseccionEnviadoByIdSeccionUpdate();
      }
    },
    async fuUpdateLms(){
      let vIdSeccions = this.dTable.selected.map(x=>x.IdSeccion).join(",");
      this.dCambiarLmsModal.IsUpdating = true;

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation update($IdCentroProd: Int!, $IdSeccion: String!, $Lms: Int!){
          matseccionlmsupdateLmsCentProd(IdCentroProd: $IdCentroProd, IdSeccion:$IdSeccion, Lms: $Lms){
                    success
                    message
                    data
            }
          }`,
          variables: {
            IdSeccion : vIdSeccions,
            IdCentroProd: this.dOrgId,
            Lms: this.dLmsId
          }
          ,
          fetchPolicy: 'no-cache'
        });
        if(response.data) {
          console.log(response.data.matseccionlmsupdateLmsCentProd);
          this.dCambiarLmsModal.dialog = false;

          Swal.fire('Correcto', 'Se guardó correctamente', 'success').then(() => {
            this.dTable.selected.forEach(item => {
              const current = this.dMatSeccions.find(el => el.IdSeccion === item.IdSeccion);
              current.Lms = this.dLmsId;
            });
          });
        }
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dCambiarLmsModal.IsUpdating = false;
      }
    },
    async fuMatseccionEnviadoByIdSeccionUpdate(){
      let vIdSeccions = this.dTable.selected.map(x=>x.IdSeccion);
      vIdSeccions = vIdSeccions.reduce((acc, el)=> acc+','+el, '');
      vIdSeccions = vIdSeccions.substring(1);
      this.dIsUpdating = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation update($IdCentroProd: Int!, $IdSeccion: String!){
          matseccionupdateLmsCentProd(IdCentroProd: $IdCentroProd, IdSeccion:$IdSeccion){
                    success
                    message
                    data
            }
          }`,
          variables: {
            IdSeccion : vIdSeccions,
            IdCentroProd: this.dOrgId
          }
        });
        if(response.data.matseccionupdateLmsCentProd.success==0){
          Swal.fire('¡ ERROR !', 'No se modifico la(s) seccion(es).', 'error');
        } else {
          Swal.fire('CORRECTO', 'Se modifico la(s) seccion(es).', 'success');
          this.fuMatseccionByActivaByEnviadoByFechas();
          this.dMatSeccions = [];
        }
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dIsUpdating = false;
      }
    },
  },
  filters: {
    fiEstado: function (value) {
      let vMessage=''
      switch (value) {
        case 0:
          vMessage=value+' - En espera de proceso';
          break;
        case 1:
          vMessage=value+' - Proceso completado';
          break;
        case 2:
          vMessage=value+' - En espera de paso 02';
          break;
        case 3:
          vMessage=value+' - En espera de paso 03';
          break;
        case 90:
          vMessage=value+' - Creación de Curso';
          break;
        case 91:
          vMessage=value+' - Asignando Administrador al Curso';
          break;
        case 92:
          vMessage=value+' - Convierte el curso en grupo Team';
          break;
        default:
          vMessage=value+' - Otro Error';
          break;
      }
      return vMessage;
    },

    fiLms: function (value) {
      let vLms=''
      switch (value) {
        case 1:
          vLms='Teams';
          break;
        case 2:
          vLms='Moodle';
          break;
        case 3:
          vLms='Canvas';
          break;
        default:
          vLms='Otro.';
          break;
      }
      return vLms;
    }
  }
}
</script>